//CRC32 lookup table
const CRC32_TABLE = (() => {
  const table = new Array<number>(256)
  const polynomial = 0xedb88320
  for (let i = 0; i < 256; i++) {
    let crc = i
    for (let j = 0; j < 8; j++) {
      crc = crc & 1 ? polynomial ^ (crc >>> 1) : crc >>> 1
    }
    table[i] = crc
  }
  return table
})()

//Calculate CRC32 checksum for a given string
export const crc32 = (input: string): number => {
  let crc = 0xffffffff
  for (let i = 0; i < input.length; i++) {
    const byte = input.charCodeAt(i)
    crc = (crc >>> 8) ^ CRC32_TABLE[(crc ^ byte) & 0xff]
  }
  return (crc ^ 0xffffffff) >>> 0
}
